module.exports = __webpack_public_path__ + "static/media/repair-no.c2ec71cd.svg";